"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("../../config");
var DRIFT_PATH = '/ai/extraction/drift';
var RUN_DIFF_PATH = '/ai/extraction/runs';
var PROMPTS_DIFF_PATH = '/ai/admin/prompts/diff';
/**
 * Thin client for the Phase 5 extraction admin endpoints. Delegates to the
 * host-supplied `apiGet`/`apiPost` helpers configured via
 * `configureAiHubLibrary`.
 */
var aiHubExtractionApiService = {
    runDriftMonitor: function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var apiPost, params, url, result, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    apiPost = config_1.getApiPost();
                    params = [];
                    if ((options === null || options === void 0 ? void 0 : options.limit) && options.limit > 0) {
                        params.push("limit=" + encodeURIComponent(options.limit));
                    }
                    if ((options === null || options === void 0 ? void 0 : options.threshold) && options.threshold > 0 && options.threshold <= 1) {
                        params.push("threshold=" + encodeURIComponent(options.threshold));
                    }
                    url = params.length ? DRIFT_PATH + "?" + params.join('&') : DRIFT_PATH;
                    return [4 /*yield*/, apiPost(url, {})];
                case 1:
                    result = _b.sent();
                    if (!result || typeof result !== 'object' || !Array.isArray(result.findings)) {
                        throw new Error('Malformed drift response');
                    }
                    return [2 /*return*/, result];
                case 2:
                    error_1 = _b.sent();
                    if (process.env.NODE_ENV !== 'production') {
                        // eslint-disable-next-line no-console
                        console.error('Error running drift monitor:', (_a = error_1) === null || _a === void 0 ? void 0 : _a.message);
                    }
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    }); },
    diffRuns: function (fromId, toId) { return __awaiter(void 0, void 0, void 0, function () {
        var apiGet, result, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    apiGet = config_1.getApiGet();
                    return [4 /*yield*/, apiGet(RUN_DIFF_PATH + "/" + fromId + "/diff/" + toId)];
                case 1:
                    result = _b.sent();
                    if (!result || typeof result !== 'object' || typeof result.useCaseId !== 'string') {
                        throw new Error('Malformed run-diff response');
                    }
                    return [2 /*return*/, result];
                case 2:
                    error_2 = _b.sent();
                    if (process.env.NODE_ENV !== 'production') {
                        // eslint-disable-next-line no-console
                        console.error('Error diffing extraction runs:', (_a = error_2) === null || _a === void 0 ? void 0 : _a.message);
                    }
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    }); },
    diffPromptVersions: function (request) { return __awaiter(void 0, void 0, void 0, function () {
        var apiPost, result, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    apiPost = config_1.getApiPost();
                    return [4 /*yield*/, apiPost(PROMPTS_DIFF_PATH, request)];
                case 1:
                    result = _b.sent();
                    if (!result || typeof result !== 'object' || !Array.isArray(result.useCases)) {
                        throw new Error('Malformed prompt-diff response');
                    }
                    return [2 /*return*/, result];
                case 2:
                    error_3 = _b.sent();
                    if (process.env.NODE_ENV !== 'production') {
                        // eslint-disable-next-line no-console
                        console.error('Error diffing prompt versions:', (_a = error_3) === null || _a === void 0 ? void 0 : _a.message);
                    }
                    throw error_3;
                case 3: return [2 /*return*/];
            }
        });
    }); },
};
exports.default = aiHubExtractionApiService;
